import React, { useEffect, useState } from "react";
import "./PopupModal.css";

export default function PopupModal() {
  const [show, setShow] = useState(false);

  // Show popup every time page loads
  useEffect(() => {
    setShow(true);
  }, []);

  const closePopup = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div
        className="popup-container"
        onClick={(e) => e.stopPropagation()}  // prevent close when clicking inside
      >
        {/* <img src="./images/popup.png" alt="Makreri Temple"  style={{width:'100%'} }/> */}
        <div style={{background:'white',padding:'25px'}}>
          <h2>Auction of Nadavaravu Items - SPST</h2>
          <table className="table table-bordered">
            <tr>
              <td>Date of Auction </td>
              <td>04-10-2026</td>
            </tr>
            <tr>
              <td>Time</td>
              <td>8.30 am to 12.30 pm</td>
            </tr>
            <tr>
              <td>Venue </td>
              <td>Mandapam* near Agrasala Ganapathi Temple</td>
            </tr>
          </table>
        </div>


        <button className="close-btn" onClick={closePopup}>
          X
        </button>
      </div>
    </div>
  );
}
